import i18n, { LOCALES } from '../../external/i18n';

i18n.addResources(LOCALES.RU, 'translation', {
  'Footer/title': 'Все права защищены',
});

i18n.addResources(LOCALES.EN, 'translation', {
  'Footer/title': 'All rights reserved',
});
